export const twClassNames = (...classes: string[]) => {
  return classes.filter(Boolean).join(' ');
};
